import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {AddressType} from './address-type';
import {map} from 'rxjs/operators';
import {ConfigUtil} from '@shared/services/config.util';

@Injectable({
  providedIn: 'root'
})
export class AddressTypeApi {
  private readonly httpClient = inject(HttpClient);

  private readonly endpoint: string;

  constructor() {
    this.endpoint = `${ConfigUtil.get('api')['backend']}/addresstypes`;
  }

  public findAll(): Observable<AddressType[]> {
    return this.httpClient.get<AddressType[]>(`${this.endpoint}`);
  }

  public findById(id: number): Observable<AddressType> {
    return this.httpClient.get<AddressType>(`${this.endpoint}/${id}`).pipe(map(value => {
      return Object.assign(new AddressType(), value);
    }));
  }

  public findByAdministration(administrationUuid: string): Observable<AddressType[]> {
    return this.httpClient.get<AddressType[]>(`${this.endpoint}?administration=${administrationUuid}`);
  }

  public save(administrationUuid: string, addressType: AddressType): Observable<AddressType> {
    return this.httpClient.post<AddressType>(`${this.endpoint}?administration=${administrationUuid}`, addressType).pipe(map(value => {
      return Object.assign(new AddressType(), value);
    }));
  }

  public update(addressType: AddressType): Observable<boolean> {
    return this.httpClient.put<boolean>(`${this.endpoint}/${addressType.id}`, addressType);
  }
}
